import React from 'react';
import { FadeIn } from './FadeIn';
import { CheckCircle2, XCircle } from 'lucide-react';
export function ForWho() {
  const isForYou = ['quieres bajar de peso sin dietas extremas', 'amas comer rico', 'necesitas algo simple', 'sales a comer o tienes vida social real', 'quieres sentir más control sin obsesionarte'];
  const notForYou = ['buscas magia sin cambiar hábitos', 'quieres un plan clínico personalizado', 'no estás dispuesto a mejorar decisiones básicas', 'esperas resultados sin constancia mínima'];
  return <section className="py-20 bg-warm-brown text-white" data-id="element-44">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-45">
        <FadeIn data-id="element-46">
          <div className="text-center mb-16" data-id="element-47">
            <h2 className="text-3xl md:text-5xl font-serif font-bold mb-6" data-id="element-48">
              Para Quién Es
            </h2>
          </div>
        </FadeIn>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 lg:gap-12" data-id="element-49">
          {/* Is for you */}
          <FadeIn direction="right" data-id="element-50">
            <div className="bg-white/10 backdrop-blur-sm rounded-3xl p-8 md:p-10 border border-white/20 h-full" data-id="element-51">
              <h3 className="text-2xl font-serif font-bold mb-8 text-warm-beige flex items-center" data-id="element-52">
                <span className="bg-olive-green text-white p-2 rounded-full mr-4" data-id="element-53">
                  <CheckCircle2 size={24} data-id="element-54" />
                </span>
                Sí es para ti si:
              </h3>
              <ul className="space-y-6" data-id="element-55">
                {isForYou.map((item, index) => <li key={index} className="flex items-start" data-id="element-56">
                    <CheckCircle2 className="text-olive-green shrink-0 mt-1 mr-4" size={20} data-id="element-57" />
                    <span className="text-lg text-white/90" data-id="element-58">{item}</span>
                  </li>)}
              </ul>
            </div>
          </FadeIn>

          {/* Not for you */}
          <FadeIn direction="left" delay={0.2} data-id="element-59">
            <div className="bg-black/20 backdrop-blur-sm rounded-3xl p-8 md:p-10 border border-black/10 h-full" data-id="element-60">
              <h3 className="text-2xl font-serif font-bold mb-8 text-white/70 flex items-center" data-id="element-61">
                <span className="bg-terracotta/80 text-white p-2 rounded-full mr-4" data-id="element-62">
                  <XCircle size={24} data-id="element-63" />
                </span>
                No es para ti si:
              </h3>
              <ul className="space-y-6" data-id="element-64">
                {notForYou.map((item, index) => <li key={index} className="flex items-start" data-id="element-65">
                    <XCircle className="text-terracotta/80 shrink-0 mt-1 mr-4" size={20} data-id="element-66" />
                    <span className="text-lg text-white/70" data-id="element-67">{item}</span>
                  </li>)}
              </ul>
            </div>
          </FadeIn>
        </div>
      </div>
    </section>;
}